import { useQuery } from '@tanstack/react-query'
import { Button } from '@/components/ui/button'
import { Drawer, DrawerSection, DrawerDetailRow, DrawerFooter } from '@/components/ui/drawer'
import { getMailById } from '@/api/mails.api'
import type { Mail } from '@/types/api'

interface MailDetailDrawerProps {
    mailId: string
    showUnitColumn?: boolean
    onClose: () => void
    onUpdate?: (mail: Mail) => void
}

export function MailDetailDrawer({ mailId, showUnitColumn, onClose, onUpdate }: MailDetailDrawerProps) {
    const { data: mail, isLoading } = useQuery({
        queryKey: ['mail-detail', mailId],
        queryFn: ({ signal }) => mailId ? getMailById(mailId, signal) : Promise.resolve(null),
        enabled: !!mailId,
        refetchOnMount: 'always',
        staleTime: 0,
        gcTime: 0,
    })

    return (
        <Drawer
            open={!!mailId}
            onClose={onClose}
            title="CHI TIẾT MAIL SERVER"
            styles={{ body: { overflow: 'auto' } }}
            footer={
                <DrawerFooter>
                    <Button variant="outline" size="md" onClick={onClose} className="min-w-[160px] h-10">Đóng</Button>
                    <Button variant="primary" size="md" onClick={() => mail && onUpdate?.(mail)} disabled={!mail || isLoading} className="min-w-[160px] h-10 bg-[#CE7A58] hover:bg-[#b8694a]">Cập nhật</Button>
                </DrawerFooter>
            }
        >
            {isLoading && <div className="p-6 text-center text-gray-500">Đang tải chi tiết...</div>}
            {mail && (
                <div>
                    <DrawerSection title="Thông tin chung" bodyClassName="pb-3">
                        {showUnitColumn && <DrawerDetailRow label="Đơn vị:" value={mail.unitName || '-'} />}
                        <DrawerDetailRow label="Máy chủ SMTP (Host/IP):" value={mail.serverUrl || '-'} />
                        <DrawerDetailRow label="Cổng:" value={mail.serverPort || '-'} />
                        <DrawerDetailRow label="Giao thức:" value={mail.protocol === 1 ? 'STARTTLS' : mail.protocol === 2 ? 'SSL/TLS' : '-'} />
                        <DrawerDetailRow label="Địa chỉ mail:" value={mail.mail || '-'} />
                        <DrawerDetailRow label="Tên hiển thị:" value={mail.name || '-'} />
                    </DrawerSection>
                </div>
            )}
        </Drawer>
    )
}